// @flow
import { useParams } from 'react-router-dom';

import { View } from 'reshaped';

import { selectOrder } from '@gandi/billing';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { Item } from './Item';

export function Items(): React.MixedElement | null {
  const params = useParams<{ orderId: string }>();
  const orderId = parseInt(params.orderId, 10);
  const order = useAppSelector(state => selectOrder(state, { orderId }));

  if (!order) return null;

  return (
    <View
      borderRadius="large"
      gap={2}
      borderColor="neutral"
      paddingBlock={4}
      paddingInline={6}
    >
      {order.items.map(item => (
        <Item item={item} currency={order.currency} />
      ))}
    </View>
  );
}
